// extracted by mini-css-extract-plugin
module.exports = {"right":"index_right_3Rzpu","user":"index_user_2rCvh","logout":"index_logout_1Y6UD","name":"index_name_2VTHk"};